import ChevronLeftOutlinedIcon from '@mui/icons-material/ChevronLeftOutlined';
import { Grid } from '@mui/material';
import { IListItem } from './IListItem';
import './listItem.css';

export default function ListItemSimple({
    title,
    icon,
    onClick,
    color,
    titleCenter,
    containerStyle,
}: IListItem) {
    return (
        <>
            <Grid
                style={{
                    border: '1px solid #BBA57A ',
                    height: '60px',
                    borderRadius: '5px',
                    background: '#fff',
                    alignContent: 'center',
                    marginTop: '60px',
                }}
                container
                spacing={0}
                onClick={() => onClick!()}
                sx={{ ...containerStyle }}
            >
                <Grid container spacing={0} xs={10}
                >
                    {icon &&
                        <div
                            style={{
                                display: 'inline-block',
                                marginRight: titleCenter ? '10px' : '20px',
                                alignSelf: 'center',
                            }}
                        >
                            {icon}
                        </div>
                    }
                    <div style={{ display: 'inline-block', marginRight: '15px', marginTop: "5px", alignSelf: titleCenter ? "center" : "" }}>
                        <span style={{ fontSize: "14px", fontWeight: "bold", color: '#BBA57A' }} className={"text-sm " + (color != undefined ? color : "primaryColorLight-900")}>{title}</span>
                    </div>
                </Grid>
                <Grid xs={2} className="leftSide" spacing={0}>

                    <ChevronLeftOutlinedIcon
                        className={"primaryColorLight-100"}
                        style={{ width: '24px', height: '24px' }}
                    />
                </Grid>

            </Grid>
        </>
    );
}
